// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setAgencyCaseManagementList,
  setAgencyCaseManagementEditItem,
  resetAgencyCaseManagement
} from 'src/store/modules/admin/agencyCaseManagement'

const initialState = {
  list: [],
  editItem: {}
}

export default handleActions(
  {
    [setAgencyCaseManagementList](state, { payload: list }) {
      return {
        ...state,
        list
      }
    },

    [setAgencyCaseManagementEditItem](state, { payload: editItem }) {
      return {
        ...state,
        editItem
      }
    },

    [resetAgencyCaseManagement]() {
      return initialState
    }
  },
  initialState
)
